export default __webpack_public_path__ + "media/images/archetypes/oracle-dbeb01a5e3580685312ee82d43109bbf.png";